import { API, graphqlOperation } from 'aws-amplify';
import { currencies } from 'dreamroi-currencies';

export default {
    namespaced:true,
    state: {
        entity: 'Domain',
        list: null,
        item: null,
        nextToken: null,
        platformSettings: {
          'EXITSHOP': {
            'imageClass': 'product_detail',
            'imageID': null
          },
          'SHOPTET': {
            'imageClass': 'p-main-image',
            'imageID': null
          },
          'WOOCOMMERCE': {
            'imageClass': 'zoomImg',
            'imageID': null
          },
          'SHOPIFY': {
            'imageClass': null,
            'imageID': null
          }
        },
        platforms: ['EXITSHOP',
          'SHOPTET',
          'SHOPIFY',
          'WOOCOMMERCE',
          'OTHER',
        ],
        currencies, 
        /*[
          {text: 'Česká koruna', sign: 'Kč', value: 'CZK' },
          {text: 'Euro (€)', sign: '€', value: 'EUR', },
          {text: 'US Dollar ($)', sign: '$', value: 'USD', format: (amount) => `$${amount}`},
          {text: 'Polsky złoty', sign: 'zł', value: 'PL'},
          {text: 'Magyar forint', sign: 'Ft', value: 'HUF'}
        ],
        */
        itemStats: null,
        statsCache: {},
        productCategories: null,
        //shopifyStore: null,
        prefill: {}
    },
    mutations: {
        list: (state, payload) => { state.list = payload.append ? (state.list || []).concat(payload.value) : payload.value },
        item: (state, payload) => { state.item = payload.value },
        nextToken: (state, payload) => { state.nextToken = payload.value },
        itemStats: (state, payload) => { state.itemStats = payload },
        statsCache: (state, payload) => { state.statsCache[payload.id] = payload },
        productCategories: (state, payload) => { state.productCategories = payload.value },
        //shopifyStore: (state, payload) => { state.shopifyStore = payload.value },
        prefill: (state, payload) => { state.prefill = Object.assign(state.prefill, payload)}
    },
    getters: {
       platformSettings: (state) => (platform) => {
         return state.platformSettings[platform];
       },
       isActive: (state) => state.item ? state.item.active == 'ACTIVE' : true,
       isIncomplete: (state) => state.item ? state.item.active == 'INCOMPLETE': true,
       isCancelled: (state) => state.item ? state.item.active == 'CANCELLED' || state.item.active == 'PURGED' : true,
       hasProducts: (state) => state.item ? (state.item.stats?.products > 0 && state.item?.productsUpdated?.substring(0,4) != '1970') : true,
       productFeedError: (state) => state.item ? (state.item.stats?.products == 0 && state.item?.productsUpdated?.substring(0,4) != '1970') : true,
       hasRecommendations: (state) => state.item ? state.item?.recommendationsUpdated?.substring(0,4) != '1970' : true,
       canAllowWebbox: (state) => state.item?.stats?.products > 0 && state.item?.recommendationsUpdated?.substring(0,4) != '1970',
       hasCampaigns: (state) => !!state.item?.campaignsUpdated,
       currenciesList: (state) => state.currencies.map(c => ({ text: `${c.text} (${c.sign}) - ${c.value}`, value: c.value}))
    },
    actions: {
        async get(context, payload) {
            const c = await API.graphql(graphqlOperation(`query GetDomain($id: ID!) {
              getDomain(id: $id) {
                id
                name
                currency
                timezone
                defaultSale
                productFeedURL
                orderFeedURL
                categoriesFeedURL
                productsUpdated
                leadscoresUpdated
                eventsPurged
                recommendationsUpdated
                campaignsUpdated
                companyID
                active
                platform
                dnsName
                mailFrom
                from
                friendlyFrom
                replyTo
                boxesAllowed
                cookieCheck
                shopifyStore
                totalEmailRecipients
                owner
                editors
                accessRights {
                  cognitoID
                  email
                  role
                }
                leadscoringSettings {
                  retention
                  visit
                  scroll {
                    value
                    score
                  }
                  time {
                    value
                    score
                  }
                  image
                  imageClass
                  imageID
                  cart
                  purchase
                  mail
                  segments {
                    percentile
                    name
                    score
                    visitors
                  }
                }
                trackingIds {
                  googleAnalytics
                  googleAdWords
                  sklik
                  facebook
                }
                homeBox { ...box }
                cartBox { ...box }
                productBox { ...box }
                capabilities {
                  allow
                  feed
                  tracker
                  viewProduct
                  signIn
                  purchase
                  #showBox
                  addToCart
                  dkim
                  spf
                  linkDomain
                  #orders
                }
                stats {
                  monthlyUsers
                  products
                  dreamroiSales
                  emailsSent
                }
                unsubscribeSetup {
                  title
                  heading
                  text
                }
              }
            }
            
				    fragment box on WebBox {
                  boxComponents
                  config
            }
            `, { id: payload.id }));
            
            context.commit('item', {value: c.data.getDomain });
            context.commit('itemStats', null);

        },
        

        async list(context, payload) {
          var filter =  payload.companyId ? { companyID: { eq : payload.companyId } } : null;
          //console.dir(filter);
          const c = await API.graphql(graphqlOperation(`
            query ListDomains(
              $filter: ModelDomainFilterInput
              $limit: Int
              $nextToken: String
            ) {
              listDomains(filter: $filter, limit: $limit, nextToken: $nextToken) {
                items {
                  id
                  name
                  productsUpdated
                  leadscoresUpdated
                  eventsPurged
                  recommendationsUpdated
                  companyID
                  active
                  currency
                  owner
                  stats {
                    monthlyUsers
                    products
                    dreamroiSales
                  }
                }
                nextToken
              }
            }
          `, { filter, nextToken: payload.nextToken }));
            context.commit('list', {value: c.data.listDomains.items, append: !!payload.nextToken });
            context.commit('nextToken', {value: c.data.listDomains.nextToken });
            if(context.state.nextToken) {
              await context.dispatch('list', { nextToken: context.state.nextToken, companyId: payload.companyId });
            }
        },

        async create(context, payload) {
          var boxTemplate = {
            domMode: 'AFTER',
            domId: null,
            boxComponents: ['IMAGE', 'NAME', 'PRICE'],
            contain: true,
            newTab: false,
            visibleProducts: 5,
            loadedProducts: null,
            gap: null,
            height: null,
            linkColor: '#0000FF',
            buttonText: 'Button',
            customArrowStyle: false,
            customCardStyle: false,
            customSplideConfig: false
          };
          var template = {
            productsUpdated: new Date('1970-01-01'),
            recommendationsUpdated: new Date('1970-01-01'),
            eventsPurged: new Date('1970-01-01'),
            leadscoresUpdated: new Date('1970-01-01'),
            companyID: this.company,
            editors: null,
            accessRightsSecret: await context.dispatch('generateSecret', null, {root: true}),
            active: 'INCOMPLETE',
            recommenderStatus: 'LEARNING',
            recommenderComputation: 'UPTODATE',
            defaultSale: 0,
            firstDayOfWeek: 1,
            totalEmailRecipients: 0,
            stats: {
              monthlyUsers: 0,
              products: 0
            },
            trackingIds: {
              googleAnalytics: null,
              googleAdWords: null,
              sklik: null,
              facebook: null
            },
            leadscoringSettings: {
              retention: 14,
              visit: 1,
              scroll: [{value: 25, score: 0 }, {value: 50, score: 2 }, {value: 75, score: 2 }, { value: 100, score: 2 }],
              time: [{value: 30, score: 1 }, {value: 60, score: 1 }, {value: 300, score: 1 }, { value: 900, score: 0 }, { value: 1800, score: 0 }],
              image: 3,
              cart: 5,
              purchase: 5,
              mail: 1,
              imageClass: null,
              imageID: null,
              segments:  [{percentile: 0, score: 0, name: 'COLD', visitors: 0 }, {percentile: 50, score: 1, name: 'WARM', visitors: 0 }, {percentile: 75, score: 2, name: 'HOT', visitors: 0 }]
            },
            capabilities: {
              allow: false, // changed below
              feed: false,
              tracker: false,
              viewProduct: false,
              signIn: false,
              purchase: false,
              showBox: false,
              addToCart: false,
              dkim: false,
              spf: false,
              linkDomain: false,
              orders: false
            },
            boxesAllowed: false,
            cookieCheck: true,
            // initialize webboxes
            homeBox: Object.assign({
              utm: {
                source: 'dreamroi',
                campaign: 'home',
                medium: 'webbox'
              }
            }, boxTemplate),
            productBox: Object.assign({
              utm: {
                source: 'dreamroi',
                campaign: 'product',
                medium: 'webbox'
              }
            }, boxTemplate),
            cartBox: Object.assign({
              utm: {
                source: 'dreamroi',
                campaign: 'cart',
                medium: 'webbox'
              }
            }, boxTemplate)
          };  
          
          Object.assign(template.capabilities, payload.capabilities);
          delete payload.capabilities;
          Object.assign(template, payload);
          // based on platform, fill in leadscoring parameters
          Object.assign(template.leadscoringSettings, context.getters.platformSettings(template.platform));
          console.debug('Creating domain', template);
          console.debug(JSON.stringify(template));
          var r = await API.graphql(graphqlOperation(`
            mutation CreateDomain(
              $input: CreateDomainInput!
              $condition: ModelDomainConditionInput
            ) {
              createDomain(input: $input, condition: $condition) {
                id
                companyID
              }
            }
          `, { input: template}));
          context.dispatch('list', { companyId: r.data.createDomain.companyID })
          return r.data.createDomain;
        },
        
        async remove(context, payload) {
          await API.graphql(graphqlOperation(/* GraphQL */ `
          mutation DeleteDomain(
            $input: DeleteDomainInput!
            $condition: ModelDomainConditionInput
          ) {
            deleteDomain(input: $input, condition: $condition) {
              id
            }
          }
          `, { input: { id: payload.id }, condition: { active: {eq: 'PURGED'}} }));
        },

        async updateFields(context, payload) {
          await API.graphql(graphqlOperation(`
            mutation UpdateDomain(
              $input: UpdateDomainInput!
              $condition: ModelDomainConditionInput
            ) {
              updateDomain(input: $input, condition: $condition) {
                id
              }
            }
          `, { input: Object.assign({ id: context.state.item.id }, payload.fields )}));
          return context.dispatch('get', { id: context.state.item.id });
          //return r.data.updateDomain;
        },

        async getProductCategories(context, payload) {
          console.debug('Store loading product categories...');
          const c = await API.graphql(graphqlOperation(`query GetDomain($id: ID!) {
            getDomain(id: $id) {
              productCategories(limit: 1000) {
                items {
                  id
                  name
                }
                nextToken
              }
            }
          }`, { id: context.state.item?.id ?? payload.domainId }));
          
          if(c.data.getDomain.productCategories.nextToken) {
            console.warn('Not all categories are loaded!');
          }
          console.debug('categories response', c);
          let items = c.data.getDomain.productCategories.items
          .filter(c => c.name != 'droiNewProducts')
          .map(c => ({ value: c.id, label: c.name}));
          
          context.commit('productCategories', {value: items });
        },

        async getDNSRecords(context /*, payload */) {
          const c = await API.graphql(graphqlOperation(`query GetDomain($id: ID!) {
            getDomain(id: $id) {
              dnsRecords
            }
          }`, { id: context.state.item.id }));
          
          // de-JSONify result
          c.data.getDomain.dnsRecords = JSON.parse(c.data.getDomain.dnsRecords);
          if(c.data.getDomain.dnsRecords.Error && c.data.getDomain.dnsRecords.Error == 'Duplicate') {
            throw c.data.getDomain.dnsRecords;
          }
          context.commit('item', {value: Object.assign(context.state.item, c.data.getDomain) });
        },

        async getStats(context, payload) {
          if(payload.allowCache) {
            console.debug('cache allowed');
            if(context.state.statsCache[payload.id]?.updated.valueOf() > (Date.now() - 60 * 60 * 1000)) {
              console.debug('cache hit');
              context.commit('itemStats', context.state.statsCache[payload.id]);
              return context.state.statsCache[payload.id];
            }
          }
          console.debug('cache not allowed');
          let from = null;
          if(payload.period) {
            
            let unit = payload.period[payload.period.length - 1];
            let amount = parseInt(payload.period.substring(0,payload.period.length - 1));
            //console.debug(`Has period ${payload.period} unit ${unit} amount ${amount}`);
            from = new Date();
            if(unit == 'd') {
              from.setDate(from.getDate() - (amount - 1));
            }
            if(unit == 'm') {
              from.setMonth(from.getMonth() - amount);
            }
            from.setHours(0,0,0,0);
          }
          //console.debug(from);
          //return;
          const q = await API.graphql(graphqlOperation(`
            query GetDomain($id: ID!, $from: AWSDateTime) {
              getDomain(id: $id) {
                sales(from: $from) {
                  total {
                    sales
                    orders
                  }
                  media {
                    sales
                    orders
                    category
                  }
                  days {
                    media {
                      sales
                      orders
                      category
                    }
                    day
                  }
                }
              }
            }
            `, { id: payload.id, from: from }));
            let stats = { id: payload.id, data: q.data.getDomain.sales, updated: new Date() };
            if(!payload.noStore) {
              context.commit('statsCache', stats);
              context.commit('itemStats', stats);
            }
            return stats;
        },

        createTag: async(context, payload) => {
          let tag = await API.graphql(graphqlOperation(`
          mutation CreateTag(
            $input: CreateTagInput!
          ) {
            createTag(input: $input) {
              id
              name
            }
          }
        `, { input: { ...payload, 
          domainID: context.state.item?.id, 
          editors: [context.state.item.owner, ...(context.state.item.editors || [])],
        }}));
        return tag.data.createTag;
        },

        createACDeal: async(context, payload) => {
          /*

          contactEmail: String!
          contactId: Int
          companyId: ID!
          domainId: ID
          name: String!
          billingCurrency: String! 
          projectCurrency: String!
          platform: String!
          registered: AWSDateTime
          companyRegistered: AWSDateTime
          */
          // disable, ac account is not active
          console.log('disabled ac deal', context, payload);
          return;
          
          // let deal = await API.graphql(graphqlOperation(`mutation CreateDeal($input:ACCreateDealInput!) {
          //     ACCreateDeal(input: $input)
          //   }`, { input: payload }));
          
          // await API.graphql(graphqlOperation(`
          //   mutation UpdateDomain($input: UpdateDomainInput!) {
          //     updateDomain(input: $input) {
          //       id
          //     }
          //   }
          // `, { input: { id: payload.domainId, acDealId: deal.data.ACCreateDeal }}));
          
          // let contactsq = await API.graphql(graphqlOperation(/* GraphQL */ `
          // query GetDomain($id: ID!) {
          //   getDomain(id: $id) {
          //     accessRights {
          //       cognitoID
          //       email
          //       role
          //     }
          //   }
          // }
          // `, { id: payload.domainId }));
          
          // let contacts = contactsq.data.getDomain.accessRights.filter(e=> e.role != 'OWNER').map(e => e.email);
          // for(let i = 0; i < contacts.length; i++) {
          //   await API.graphql(graphqlOperation(`mutation AddContact($input:ACContactDealInput!) {
          //     ACAddContactToDeal(input: $input)
          //   }`, { input: { dealId: deal.data.ACCreateDeal, contactEmail: contacts[i] } }));
          // }
          
        },

        shopifyCreateTags: async(context, payload) => {
          let result = await API.graphql(graphqlOperation(`mutation CreateShopifyTags($store:String!) {
            shopifyCreateScriptTag(shopifyStore: $store)
          }`, { store: payload.store }));
          return result;
        },


        shopifyRedirect: async(context, payload) => {
          let result = await API.graphql(graphqlOperation(/* GraphQL */ `query GetDroiIDs($store:String!) {
            shopifyGetDroiIds(shopifyStore: $store) {
              companyID
              domainID
            }
          }`, { store: payload.store }));
          return result.data?.shopifyGetDroiIds;
        },

        shopifyGetThemes: async(context, payload) => {
          let themes = await API.graphql(graphqlOperation(/* GraphQL */ `
          query GetDomain($id: ID!) {
            getDomain(id: $id) {
              shopifyThemes
            }
          }
          `, { id: payload.id }));
          return JSON.parse(themes.data.getDomain.shopifyThemes);
        }
    }
}